import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, useMediaQuery, useTheme, Badge } from "@mui/material";
import { signOut } from "aws-amplify/auth";
import { Logout } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

import { navListItems } from "./NavListItems";

export default function DrawerList({ selectedItem, setSelectedItem, onItemSelect }: any) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const role = useSelector((state: any) => state.authentication.userRole);
  const totalAlerts = useSelector((state: RootState) => state.alerts.total_alerts);
  const navigate = useNavigate();

  const handleNavItemClick = (item: (typeof navListItems)[number]) => {
    setSelectedItem(item);
    navigate(item?.path);
    if (isSmallScreen) onItemSelect();
  };

  const clearOrUpdateLocalStorage = () => {
    localStorage.setItem("loggedIn", "false");
    localStorage.removeItem("energyType");
    localStorage.removeItem("siteSortModel");
    localStorage.removeItem("sitePaginationModel");
    localStorage.removeItem("projectSortModel");
    localStorage.removeItem("projectPaginationModel");
    localStorage.removeItem("unitSortModel");
    localStorage.removeItem("unitPaginationModel");
    localStorage.removeItem("alertSortModel");
    localStorage.removeItem("alertPaginationModel");
    localStorage.removeItem("userSortModel");
    localStorage.removeItem("userPaginationModel");
    localStorage.removeItem("adminSortModel");
    localStorage.removeItem("adminPaginationModel");
  };

  const handleLogout = () => {
    clearOrUpdateLocalStorage();
    signOut();
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
      }}
    >
      <List>
        {navListItems
          .filter((item) => !(item.navText === "Insurtech Solutions" && role !== "SUPERADMIN")) // Filter out InsurtechAI if role is not SUPERADMIN
          .map((item) => (
            <ListItem key={item.id} disablePadding>
              <ListItemButton
                onClick={() => handleNavItemClick(item)}
                selected={item.id === selectedItem.id}
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: "#A4DAD6",
                  },
                }}
              >
                <ListItemText primary={item.navText} />
                {item.navText === "Alerts" && totalAlerts > 0 && (
                  <Badge
                    sx={{
                      "& .MuiBadge-badge": {
                        right: 8,
                      },
                    }}
                    badgeContent={totalAlerts < 100 ? totalAlerts : "99+"}
                    color="error"
                  />
                )}
              </ListItemButton>
            </ListItem>
          ))}
      </List>
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={() => handleLogout()}>
            <ListItemIcon>
              <Logout color="primary" />
            </ListItemIcon>
            <ListItemText primary={"Log out"} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );
}
